import { createAction, props } from '@ngrx/store';
import { AssignDocumentResult } from 'src/app/compliance/models/posted-documents-models';
import { CandidateVaccine } from 'src/app/compliance/models/candidate-vaccine.model';
import dayjs from 'dayjs';
import { DocumentAttribute } from 'src/app/shared/lib/compliance-shared/document-attributes-form/document-attributes-form.store';

export const assignCandidateDocumentType = createAction(
    '[DOCUMENT REVIEWER DOC TYPE SELECTION] Document Reviewer Assign Candidate Document Type',
    props<{ vaccine?: CandidateVaccine }>()
);

export const assignCandidateDocumentTypeWithArgs = createAction(
    '[DOCUMENT REVIEWER DOC TYPE SELECTION] Document Reviewer Assign Candidate Document Type With Args',
    props<{
        expiration: dayjs.Dayjs;
        docNote: string;
        documentAttributes: DocumentAttribute[];
    }>()
);

export const assignCandidateDocumentTypeSuccess = createAction(
    '[DOCUMENT REVIEWER DOCUMENT ASSIGNMENT] Document Reviewer Assign Candidate Type Success',
    props<{ assignResult: AssignDocumentResult }>()
);

export const assignCandidateDocumentPages = createAction(
    '[DOCUMENT REVIEWER DOCUMENT ASSIGNMENT] Document Reviewer Assigned Pages',
    props<{ pageCount: number }>()
);

export const assignCandidateDocumentTypeFailure = createAction(
    '[DOCUMENT REVIEWER DOCUMENT ASSIGNMENT] Document Reviewer Assign Candidate Type Failure',
    props<{ error: unknown }>()
);

export const updateCandidateVaccineInformation = createAction(
    '[VAL QUEUE COMPONENT] Update Candidate Vaccine Information',
    props<{ vaccine: CandidateVaccine; candidateDocId: number; docTypeId: number }>()
);

export const updateCandidateVaccineInformationSuccess = createAction(
    '[VAL QUEUE COMPONENT] Update Candidate Vaccine Information Success'
);

export const updateCandidateVaccineInformationFailure = createAction(
    '[VAL QUEUE COMPONENT] Update Candidate Vaccine Information Failure',
    props<{ error: unknown }>()
);

export const assignAndFillPositionSuccess = createAction(
    '[DOCUMENT REVIEWER DOCUMENT ASSIGNMENT] Document Reviewer Post Assignment Signed Contract Actions Success'
);

export const assignAndFillPositionFailure = createAction(
    '[DOCUMENT REVIEWER DOCUMENT ASSIGNMENT] Document Reviewer Post Assignment Signed Contract Actions Failure',
    props<{ error: unknown }>()
);
